<template>
  <div class="monitor">
    <div class="monitor__row monitor__title">
      <h2 v-if="monitor.meta.name">{{ monitor.meta.name }}</h2>
      <h2 v-else>{{ monitor.meta.attributes.name }}</h2>
      <div class="state" :class="statusClass" v-text="statusText"></div>
    </div>
    <div class="monitor__bar svg-container" v-if="uptime">
      <UptimeBar :days="monitor.meta.availability"></UptimeBar>
    </div>
    <div class="monitor__row monitor__bottom" v-if="uptime">
      <div class="monitor__last90">&nbsp;</div>
      <div class="monitor__uptime">{{ uptime }}% uptime</div>
      <div class="monitor__today">Today</div>
    </div>
    <div v-else>
      <div class="monitor__row monitor__bottom monitor__bottom--nodata">
        Historical data will be available soon.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    monitor: {
      type: Object,
      required: true,
    },
  },
  computed: {
    statusClass() {
      if (this.monitor.meta.attributes.status !== 1) {
        return "disabled";
      }
      if (this.monitor.meta.attributes.state === 10) {
        return "operational";
      }
      if (this.monitor.meta.attributes.state === -10) {
        return "outage";
      }
      return "warning";
    },
    statusText() {
      if (this.monitor.meta.attributes.status !== 1) {
        return "Disabled";
      }
      if (this.monitor.meta.attributes.state === 10) {
        return "Operational";
      }
      if (this.monitor.meta.attributes.state === -10) {
        return "Outage";
      }
      if (this.monitor.meta.attributes.state === 0) {
        return "Pending";
      }
      return "Unknown";
    },
    uptime() {
      let sum = 0,
        count = 0;
      this.monitor.meta.availability
        .filter((element) => element.availability !== null)
        .forEach((element) => {
          sum += element.availability;
          count += 1;
        });
      return Math.round((sum / count) * 10000) / 10000;
    },
  },
  components: {
    UptimeBar: () => import("@/components/UptimeBar.vue"),
  },
};
</script>

<style lang="scss">
.monitor {
  margin: 0 0.5rem 1.5rem;
  &__bar {
    text-align: center;
  }
  &__title {
    padding: 0 0.5rem 0 0;
  }
  &__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.5rem 0;
  }
  &__today {
    padding-right: 0.5rem;
  }

  .svg-container {
    display: inline-block;
    position: relative;
    width: 100%;
    padding-bottom: 5.5%;
    vertical-align: middle;
    overflow: hidden;
  }
}
</style>
